import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Shield } from 'lucide-react';
export const Guarantee: React.FC = () => {
  return <SectionWrapper data-id="element-83">
      <div className="max-w-3xl mx-auto bg-navy border-4 border-gold rounded-2xl p-8 md:p-12 text-center shadow-2xl relative" data-id="element-84">
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-navy rounded-full p-2" data-id="element-85">
          <Shield className="text-gold w-20 h-20" fill="#D4AF37" fillOpacity={0.1} strokeWidth={1.5} data-id="element-86" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-gold mt-8 mb-6" data-id="element-87">
          Garantía de Confianza Total — 7 Días
        </h2>

        <p className="text-lg md:text-xl text-white leading-relaxed mb-8" data-id="element-88">
          Si aplicas el Método MRA, vas a tu cita y sientes que el protocolo no
          te preparó como esperabas, escríbeme directamente y te devuelvo el
          100% de tu dinero. Sin preguntas. Sin formularios. Sin burocracia. El
          riesgo es completamente mío — no tuyo.
        </p>

        <p className="text-xl text-gold italic font-semibold" data-id="element-89">
          — Edison Ricardo Ramírez, Creador del Método MRA
        </p>
      </div>
    </SectionWrapper>;
};